// extracted by mini-css-extract-plugin
module.exports = {"helpIframe":"index_helpIframe__arMRs","icon":"index_icon__pBMav"};